import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  color: rgb(51, 51, 51);\n  ", "\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      padding: ", ";\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import GroupContext from './GroupContext';
import CheckboxInput from './CheckboxInput';
import { legacySwappableCss } from '../../theme';
// LEGACY theme
var legacyContainerCss = 'margin: 3px 0px 7px 0px;';
var legacyLabelCss = "\n  margin-bottom: 10px;\n  font-size: 18px;\n  font-weight: 300;\n"; // END LEGACY theme

var CheckboxGroupContainer = styled.div(_templateObject(), legacySwappableCss(legacyContainerCss, css(_templateObject2(), function (p) {
  return p.theme.spacing(0, 2, 2, 2);
})));
var Label = styled.span(_templateObject3(), function (p) {
  return p.theme.fontCss('body', true);
}, legacySwappableCss(legacyLabelCss, ''));

var getAllChildValues = function getAllChildValues(children) {
  return React.Children.map(children, function (child) {
    return child.props.value;
  });
};

var CheckboxGroup = function CheckboxGroup(_ref) {
  var name = _ref.name,
      children = _ref.children,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? [] : _ref$value,
      disabled = _ref.disabled,
      label = _ref.label,
      parent = _ref.parent;

  var _useState = useState(value),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var _useState3 = useState({
    checked: false,
    indeterminate: false
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      parentState = _useState4[0],
      setParent = _useState4[1];

  var setParentState = function setParentState(_value) {
    if (_value.length === getAllChildValues(children).length) {
      setParent({
        checked: true,
        indeterminate: false
      });
    } else if (_value.length === 0) {
      setParent({
        checked: false,
        indeterminate: false
      });
    } else {
      setParent({
        checked: false,
        indeterminate: true
      });
    }
  };

  var handleChildClick = function handleChildClick(child) {
    var childValue = child.target.value;
    var index = state.indexOf(childValue, 0);

    if (index >= 0) {
      state.splice(index, 1);
    } else {
      state.push(childValue);
    }

    setParentState(state);
    setState(state);
  };

  var cloneChild = function cloneChild(child) {
    return React.cloneElement(child, {
      onChange: function onChange(event) {
        return handleChildClick(event);
      }
    });
  };

  function handleParentClick() {
    var tempValue;

    if (state.length === getAllChildValues(children).length) {
      // eslint-disable-next-line fp/no-mutation
      tempValue = [];
      setParent({
        checked: false,
        indeterminate: false
      });
    } else {
      // eslint-disable-next-line fp/no-mutation
      tempValue = getAllChildValues(children);
      setParent({
        checked: true,
        indeterminate: false
      });
    }

    setState(tempValue);
  }

  return /*#__PURE__*/React.createElement(GroupContext.Provider, {
    value: {
      name: name,
      value: state,
      disabled: disabled
    }
  }, parent ? /*#__PURE__*/React.createElement(CheckboxInput, _extends({}, parentState, {
    value: "parent",
    label: label,
    onChange: function onChange() {
      return handleParentClick();
    }
  })) : label && /*#__PURE__*/React.createElement(Label, {
    id: "".concat(name, "-label")
  }, label), /*#__PURE__*/React.createElement(CheckboxGroupContainer, {
    role: "group",
    "aria-labelledby": "".concat(name, "-label")
  }, React.Children.map(children, function (child) {
    return cloneChild(child);
  })));
};

export default CheckboxGroup;